import React, { FC, ReactNode, useState } from 'react'

import classNames from 'classnames'

import Title from '@models/Title'

import CoverArtOverlay from './CoverArtOverlay'

interface Props {
  title: Title
  className?: string
  children?: ReactNode
}

const CoverArtImage: FC<Props> = ({ title, children, className }) => {
  const [imgLoaded, setImgLoaded] = useState(false)

  return (
    <div
      className={classNames(
        "after:content-[''] after:block after:pb-full relative group bg-white shadow-none sm:shadow-lg shadow-gray-text overflow-hidden",
        className
      )}>
      {title.metadata.cover_art_url && (
        <img
          alt="Cover Art"
          src={title.metadata.cover_art_url}
          onLoad={() => setImgLoaded(true)}
          className={classNames(
            'absolute w-full h-auto group-hover:brightness-[0.8] bg-white transition-opacity',
            imgLoaded ? 'opacity-100' : 'opacity-0'
          )}
        />
      )}
      <CoverArtOverlay directive={title.metadata.cover_art_directive} />
      {children}
    </div>
  )
}

export default CoverArtImage
